module.exports = __webpack_public_path__ + "img/33.3fe2a893.png";